import { useContext } from 'react';
import { ComponentConfigContext } from 'js/components/hocs/withComponent/context';

export const useComponentConfig = <TConfig = any>() => useContext<TConfig>(ComponentConfigContext);
